module.exports = __webpack_public_path__ + "435e0cda99de761092d0494ffebd2bac.pdf";